// utils/CreateLayers.js
import { GeoJsonLayer } from '@deck.gl/layers';

export const createLayers = (
  points,
  multiPoints,
  lines,
  multiLines,
  polygons,
  multiPolygons,
  addedCoordinate,
  geometryType,
  geometryName,
  featureProperties,
) => {
  const layers = [
    new GeoJsonLayer({
      id: 'drawn-features-layer',
      data: {
        type: 'FeatureCollection',
        features: [
          ...points.map(point => ({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: point.coordinates
            },
            properties: { ...featureProperties },
            geometry_name: point.geometry_name
          })),
          ...multiPoints,
          ...lines.map(line => ({
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: line.coordinates
            },
            properties: { ...featureProperties },
            geometry_name: line.geometry_name
          })),
          ...multiLines.map(multiLine => ({
            type: 'Feature',
            geometry: {
              type: 'MultiLineString',
              coordinates: multiLine.coordinates
            },
            properties: { ...featureProperties },
            geometry_name: multiLine.geometry_name
          })),
          ...polygons.map(polygon => ({
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: polygon.coordinates
            },
            properties: { ...featureProperties },
            geometry_name: polygon.geometry_name
          })),
          ...multiPolygons.map(multiPolygon => ({
            type: 'Feature',
            geometry: {
              type: 'MultiPolygon',
              coordinates: multiPolygon.coordinates
            },
            properties: { ...featureProperties },
            geometry_name: multiPolygon.geometry_name
          }))
        ]
      },
      pickable: true,
      stroked: true,
      filled: false,
      pointType: 'circle',
      lineWidthMinPixels: 2,
      lineWidthScale: 2,
      getFillColor: [255, 0, 0, 200],
      getLineColor: [0, 0, 0, 200],
      getPointRadius: 200,
      getLineWidth: 2,
      onError: (error) => console.error('GeoJsonLayer error:', error),
    }),
    addedCoordinate && addedCoordinate.length > 0 && new GeoJsonLayer({
      id: 'current-drawing-layer',
      data: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: geometryType === 'Polygon' || geometryType === 'MultiPolygon' ? 'Polygon' : 'LineString',
              coordinates: geometryType === 'Polygon' || geometryType === 'MultiPolygon'
                ? [addedCoordinate.concat([addedCoordinate[0]])]
                : addedCoordinate
            },
            properties: {},
            geometry_name: geometryName
          }
        ]
      },
      pickable: true,
      stroked: true,
      filled: false,
      pointType: 'circle',
      lineWidthMinPixels: 2,
      lineWidthScale: 2,
      getFillColor: [255, 0, 0, 200],
      getLineColor: [255, 140, 0],
      getPointRadius: 200,
      getLineWidth: 2,
    }),
    addedCoordinate && addedCoordinate.length > 0 && new GeoJsonLayer({ // NOVI layer za tačke
      id: 'drawing-points-layer',
      data: {
        type: 'FeatureCollection',
        features: addedCoordinate.map(coord => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: coord
          },
          properties: {}
        }))
      },
      pickable: false,
      pointType: 'circle',
      getPointRadius: 5,
      getFillColor: [58, 51, 96, 255],
      getLineColor: [255, 255, 255, 255],
      stroked: true,
    })
  ].filter(Boolean);

  return layers;
};